import type { Source } from "@/lib/api/catalogue";
import { SOURCE_NAME } from "@/lib/applications";

/** Which vendor a board or posting is on, as the small uppercase pill. */
export default function SourceTag({
    source,
    size = "sm",
}: {
    source: Source | null;
    size?: "sm" | "md";
}) {
    if (!source) return null;
    const text = size === "sm" ? "text-[10px]" : "text-small";
    return (
        <span
            className={`inline-flex shrink-0 items-center rounded-full border border-line-strong px-1.5 py-px ${text} font-semibold uppercase tracking-[0.06em] text-fg-faint`}
        >
            {SOURCE_NAME[source]}
        </span>
    );
}
